import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { useUID } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useTranslation } from "@coworker/locales";
import { memo } from "react";

interface TaskViewerSheetFooterProps {
  showNoFooter: boolean;
  originalTask: Task | undefined;
  isSaving: boolean;
  isFetchingOriginalTask: boolean;
  hasUnsavedChanges: boolean;
  isDisabled: boolean;
  isCompleteDisabled?: boolean;
  onSaveClick: () => void;
  onCompleteClick: () => void;
  onPickUpClick: () => void;
}

export const TaskViewerSheetFooter = memo(
  (props: TaskViewerSheetFooterProps) => {
    const {
      showNoFooter,
      originalTask,
      isSaving,
      isFetchingOriginalTask,
      hasUnsavedChanges,
      onCompleteClick,
      onPickUpClick,
      onSaveClick,
      isDisabled,
      isCompleteDisabled,
    } = props;
    const myUserId = useUID();
    const { t } = useTranslation();
    if (showNoFooter) {
      return null;
    } else {
      function createFooterContent() {
        if (!originalTask || isSaving || isFetchingOriginalTask) {
          return (
            <FixaButton
              data-testid={"viewer-sheet-footer-loading-button"}
              loading
              type="primary"
            />
          );
        } else if (originalTask.state === "pending") {
          if (originalTask.assigned_user_id === myUserId) {
            if (hasUnsavedChanges) {
              return (
                <>
                  <FixaButton
                    data-testid={"viewer-sheet-footer-save-button"}
                    text={t("saveString")}
                    onClick={onSaveClick}
                    type="primary"
                    disabled={isDisabled}
                  />
                  <FixaButton
                    data-testid={"viewer-sheet-footer-save-and-complete-button"}
                    text={t("saveAndCompleteString")}
                    onClick={onCompleteClick}
                    disabled={isCompleteDisabled}
                  />
                </>
              );
            } else {
              return (
                <FixaButton
                  data-testid={"viewer-sheet-footer-complete-button"}
                  text={t("completeString")}
                  onClick={onCompleteClick}
                  type="primary"
                  disabled={isCompleteDisabled}
                />
              );
            }
          } else {
            if (hasUnsavedChanges) {
              return (
                <>
                  <FixaButton
                    data-testid={"viewer-sheet-footer-save-button"}
                    text={t("saveString")}
                    onClick={onSaveClick}
                    type="primary"
                    disabled={isDisabled}
                  />
                  <FixaButton
                    data-testid={"viewer-sheet-footer-save-and-pick-up-button"}
                    text={t("saveAndPickUpString")}
                    onClick={onPickUpClick}
                    disabled={isDisabled}
                  />
                </>
              );
            } else {
              return (
                <FixaButton
                  data-testid={"viewer-sheet-footer-pick-up-button"}
                  text={t("pickUpString")}
                  onClick={onPickUpClick}
                  type="primary"
                  disabled={isDisabled}
                />
              );
            }
          }
        } else {
          if (hasUnsavedChanges) {
            return (
              <FixaButton
                data-testid={"viewer-sheet-footer-save-button"}
                text={t("saveString")}
                onClick={onSaveClick}
                type="primary"
                disabled={isDisabled}
              />
            );
          } else {
            return null;
          }
        }
      }

      return <FixaModalFooter>{createFooterContent()}</FixaModalFooter>;
    }
  }
);
